import { Input as AInput, Col, Form, Modal, Row, message } from 'antd';
import React, { FC, ReactElement, useEffect, useMemo, useState } from 'react';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch, compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled, { css } from 'styles/styled-components';
import { ApplicationRootState } from 'types';
import utilsMessages from 'utils/messages';
import orderMessage from '../../containers/OrdersPage/messages';

import Input from 'components/TrackingComponents/Input';

import { selectBuyer } from 'containers/MainLayout/selectors';
import translations from 'translations';
import SVGIcon from '../SVGIcon/SVGIcon';
import LightBuldCircle from './LightbulbCircle.svg';
import { findFullAddress, handleStore } from './action';
import Dismiss from './images/Dismiss.svg';
import reducer from './reducer';
import saga from './saga';
import selectCreateStorePopupComponent from './selectors';

import { CheckCircleOutlined } from '@ant-design/icons';
import AddressForMap from 'components/AddressForMap';
import Button from 'components/Button/Button';
import { Avatar } from 'components/Company/Avatar';
import { push } from 'connected-react-router';
import { NewImageUploadButton } from 'containers/ChangeStorePage';
import changeStoreMessages from 'containers/ChangeStorePage/messages';
import { GoogleMapsContextProvider } from 'containers/LandingPage/DistributionLocationPage/components/Map/hooks/GoogleMapScriptContext';
import media from 'utils/mediaStyle';
import { Store } from '../../types/schema';
import RedInvoice from './components/RedInvoice';
import StoreMapWrapper from './components/StoreMapWrapper';
import { DEFAULT_REGION_COORDS, FIELD_NAME_FULL_TEXT, INITIAL_CAMERA } from './constants';
import useWatchFieldChange from './hooks/useWatchFieldChange';
import messages from './messages';

// import LocationFormSection from '../../components/LocationFormSection';
const { confirm } = Modal;
interface IStateProps {
  buyer: any;
  createStorePopupState: any;
}

interface IDispatchProps {
  handleStoreInfo: (payload: any) => void;
  findFullAddress: (payload: any) => void;
  gotoChangeStorePage: () => void;
}

interface IOwnProps {
  isUpdate?: boolean;
  currentStoreData?: Store;
}

const PopupCreateStore = styled(Modal)`
  width: 100% !important;
  max-width: ${({ isUpdate }) => (isUpdate ? '652px' : '1000px')};
  .ant-modal-content {
    top: -62px;
    padding: 24px !important;
  }
  top: 0;
  ${media.sm`
    top: 100px;
  `}
  .ant-modal-header {
    margin: -12px -24px 0px;
    line-height: 24px;
    font-size: 16px;
    font-weight: 700;
    padding: 0 24px 12px;
    border-bottom: 1px solid #d0d5dd;
  }
`;

const FormItem = styled(Form.Item)`
  margin-bottom: 12px !important;
`;
const TitleWrapper = styled.div`
  text-align: center;
  margin-inline: 0;
  margin-bottom: 20px;
`;
const FormTitle = styled.h3`
  font-size: 20px;
  font-weight: 500;
`;
const FormSubTitle = styled.span`
  font-size: 14px;
  font-weight: 400;
`;
const Note = styled.div`
  display: flex;
  align-items: start;
  gap: 4px;
  background: #fffbeb;
  padding: 6px 4px;
  border-radius: 3px;
  margin-bottom: 8px;
`;

const NoteIcon = styled(SVGIcon)`
  & svg path {
    stroke: #f5ce47;
  }
`;

const NoteText = styled.div`
  line-height: 16px;
  font-size: 14px;
  font-weight: 400;
  text-align: start;
`;

const StoreNameViewOnly = styled(Col)`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: center;
`;
const SeparateLine = styled.div`
  position: relative;
  top: 3px;
  width: 1px;
  height: 18px;
  background-color: #cacbce;
  margin: 0 auto;
`;

const AntdInput = styled(AInput)<any>``;

const Heading = styled.h4`
  margin-bottom: 6pt;
  color: #343538;
  font-family: 'Maven Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
`;

const DivideLine = styled.div`
  width: 100%;
  height: 1px;
  background: #eaebea;
  margin: 0 0 20px;
`;

const SectionTitle = styled.div`
  color: #7c7c7c;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  margin-bottom: 8px;
`;

const AvatarEl = styled.div`
  & > div > div > img {
    height: 170px !important;
    object-fit: contain;
  }
`;

const newAvatarWrapperStyle = css`
  height: 212px;
  padding: 20px;
  border-color: #eaeaeb;
  background: #fcfcfd;
`;

const InfoContainer = styled.div`
  margin-bottom: 6pt;
`;

type Props = IStateProps & IDispatchProps & IOwnProps;

interface IUpdateInfoFirstStoreFormProps {
  form: any;
  imageUrl?: string;
  onSetImageUrl?: (url: string) => void;
  setFetchingInvoice?: (state: boolean) => void;
  addressComponent: ReactElement;
}

const UpdateInfoFirstStoreForm: FC<IUpdateInfoFirstStoreFormProps> = ({
  form,
  onSetImageUrl,
  imageUrl,
  addressComponent,
  setFetchingInvoice,
}) => {
  const formatPhoneNumber = () => {
    if (form.getFieldError('telephone').length) {
      return;
    }
    const regex = /[()+\-.\s]/g;
    const phoneNumberValue = form.getFieldValue('telephone');
    form.setFieldValue('telephone', phoneNumberValue.replace(regex, ''));
  };
  return (
    <div style={{ marginTop: '20px' }}>
      <SectionTitle>{translations(messages.storeInfo)}</SectionTitle>
      <Row gutter={24}>
        <Col lg={8} xs={24}>
          <Heading>{translations(changeStoreMessages.storeImage)}</Heading>
          <AvatarEl>
            <Avatar
              src={imageUrl}
              onUploadImageSuccess={onSetImageUrl}
              ImageControlsComponent={NewImageUploadButton}
              highlight
              customAvatarStyle={newAvatarWrapperStyle}
            />
          </AvatarEl>
        </Col>
        <Col lg={16} xs={24}>
          <InfoContainer>
            <Row gutter={8}>
              <Col lg={12} xs={24}>
                <FormattedMessage {...orderMessage.storeName}>
                  {(storeName) => (
                    <FormattedMessage {...utilsMessages.fieldRequired} values={{ field: storeName }}>
                      {(fieldRequired) => (
                        <Form.Item
                          name="name"
                          label={storeName}
                          colon={false}
                          rules={[
                            { required: true, message: fieldRequired },
                            { pattern: /[a-zA-Z]/g, message: fieldRequired },
                          ]}
                          hasFeedback={false}
                        >
                          <Input
                            InputComponent={AntdInput}
                            trackingCategory="Edit Store Form | Input"
                            trackingAction="Enter Store name"
                            type="text"
                          />
                        </Form.Item>
                      )}
                    </FormattedMessage>
                  )}
                </FormattedMessage>
              </Col>
              <Col lg={12} xs={24}>
                <FormattedMessage {...utilsMessages.phone}>
                  {(phone) => (
                    <FormattedMessage {...utilsMessages.fieldRequired} values={{ field: phone }}>
                      {(fieldRequired) => (
                        <Form.Item
                          name="telephone"
                          label={phone}
                          colon={false}
                          rules={[
                            { required: true, message: fieldRequired },
                            {
                              pattern: /^(?=(?:[()+\-.\s]*\d){9,12}$)[()+\-.,\s\d]*$/,
                              message: translations(messages.invalidPhoneNumber),
                            },
                          ]}
                          hasFeedback={false}
                        >
                          <Input
                            InputComponent={AntdInput}
                            trackingCategory="Edit Store Form | Input"
                            trackingAction="Enter Phone"
                            type="text"
                            onBlur={formatPhoneNumber}
                          />
                        </Form.Item>
                      )}
                    </FormattedMessage>
                  )}
                </FormattedMessage>
              </Col>
            </Row>
            {addressComponent}
          </InfoContainer>
        </Col>
      </Row>
      <DivideLine />
      <Row>
        <Col span={24}>
          <SectionTitle>{translations(messages.redInvoiceInfo)}</SectionTitle>
          <RedInvoice form={form} setFetchingInvoice={setFetchingInvoice} />
        </Col>
      </Row>
    </div>
  );
};

const CreateStorePopup: FC<Props> = (props) => {
  const {
    buyer,
    handleStoreInfo,
    findFullAddress,
    createStorePopupState,
    isUpdate,
    currentStoreData,
    gotoChangeStorePage,
  } = props;
  const regions = buyer?.region ? [buyer?.region] : [];
  const [form] = Form.useForm();
  const [openExtendedMap, setOpenExtendedMap] = useState(false);
  const [placeId, setPlaceId] = useState<string>('');
  const [coords, setCoords] = useState<google.maps.LatLngLiteral | null>(null);
  const [isOutOfRegion, setIsOutOfRegion] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [isFetchingInvoice, setIsFetchingInvoice] = useState(false);
  const [storeImg, setStoreImg] = useState('');

  const [messageApi, contextHolder] = message.useMessage();
  const { isReadyToSubmit, isMissingWard } = useWatchFieldChange(form, regions);

  const currentAddressDetail = isUpdate ? currentStoreData?.location?.address : buyer?.location?.address;

  const isOpenPopup = useMemo(() => {
    if (isUpdate) {
      return currentStoreData && currentStoreData.isForceUpdate;
    }
    return !buyer.loading && buyer?.id && buyer.stores?.[0]?.id && !buyer.stores?.[0]?.geoPlusCode;
  }, [buyer, currentStoreData, isUpdate]);

  useEffect(() => {
    form.setFieldValue('geoLat', coords?.lat);
    form.setFieldValue('geoLon', coords?.lng);
  }, [coords?.lat, coords?.lng]);

  useEffect(() => {
    const defaultCoords = regions?.length ? DEFAULT_REGION_COORDS[regions[0]] : null;
    setCoords(defaultCoords);
  }, [regions[0]]);

  const onSubmit = () => {
    form.submit();
  };

  const handleShowWarning = () => {
    if (!openExtendedMap) {
      messageApi.open({
        type: 'error',
        content: (
          <FormattedMessage
            {...messages.warningTitle}
            values={{
              region: translations(utilsMessages[regions?.[0] || '']),
            }}
          />
        ),
        icon: (
          <SVGIcon
            style={{ cursor: 'pointer' }}
            src={Dismiss}
            renderAsImg={false}
            onClick={() => messageApi.destroy()}
          />
        ),
        className: 'out-of-region-warning',
        style: {
          marginInline: 'auto',
        },
      });
    }
  };

  const validateRedInvoice = (redInvoice: any) => {
    const hasValueFields = Object.values(redInvoice).some((value) => value);
    let isValid = true;
    if (hasValueFields) {
      Object.entries(redInvoice).forEach(([key, value]) => {
        if (!value && ['redInvoiceCompanyName', 'taxCode'].includes(key)) {
          isValid = false;
          form.setFields([
            {
              name: key,
              errors: [translations(messages.pleaseFillOutThisField)],
            },
          ]);
        }
      });
    }
    return isValid;
  };

  useEffect(() => {
    if (isOpenPopup) {
      if (isUpdate && currentStoreData && Object.keys(currentStoreData).length) {
        form.setFieldsValue({
          name: currentStoreData?.name || undefined,
          telephone: currentStoreData?.telephone || undefined,
        });
      } else {
        if (buyer.id && !buyer.stores?.length) {
          gotoChangeStorePage();
          return;
        }
        const {
          name,
          telephone,
          redInvoice: { address, companyName, email, mst },
        } = buyer.stores?.[0];
        form.setFieldsValue({
          name: name || undefined,
          telephone: telephone || undefined,
          taxCode: mst || '',
          redInvoiceCompanyName: companyName || '',
          redInvoiceEmail: email || '',
          redInvoiceAddress: address || '',
        });
      }
    } else {
      if (buyer.id && !buyer.stores?.length) {
        gotoChangeStorePage();
      }
    }
  }, [buyer.id, isOpenPopup, buyer.stores]);
  return (
    <GoogleMapsContextProvider
      apiKey={process.env.GOOGLE_MAP_API || ''}
      language="vi"
      region="VN"
      libraries={['maps', 'geocoding', 'marker', 'places']}
      mapCameraProps={INITIAL_CAMERA}
    >
      {contextHolder}
      <PopupCreateStore
        open={isOpenPopup}
        closeIcon={false}
        zIndex={1000000}
        footer={[
          (!isReadyToSubmit || !isMissingWard || !placeId) && (
            <Note>
              <NoteIcon src={LightBuldCircle} renderAsImg={false} />
              <NoteText>{translations(utilsMessages.createFirstStoreNoteText)}</NoteText>
            </Note>
          ),
          <div key="confirmButton" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Button
              key="submit"
              type="bg-primary"
              onClick={onSubmit}
              disabled={(!isReadyToSubmit && loading) || isFetchingInvoice}
              loading={createStorePopupState?.loading || loading}
              style={{
                cursor: isReadyToSubmit && !loading ? 'pointer' : 'not-allowed',
                opacity: isReadyToSubmit && !loading ? 1 : 0.5,
                width: 'fit-content',
              }}
              icon={isReadyToSubmit && !loading ? <CheckCircleOutlined /> : ''}
              block
            >
              <FormattedMessage {...utilsMessages.finish} />
            </Button>
          </div>,
        ]}
        title={!isUpdate ? translations(messages.storeConfirmInfo) : null}
        isUpdate={isUpdate}
        confirmLoading={createStorePopupState?.loading}
      >
        {/* <CreateStoreBannerImage /> */}
        {isUpdate && (
          <TitleWrapper>
            <FormTitle>
              <FormattedMessage {...utilsMessages.updateStoreAddress} />
            </FormTitle>
            {isReadyToSubmit && isMissingWard && placeId && (
              <FormSubTitle>
                <FormattedMessage {...utilsMessages.storeConfimSubText} />
                <p style={{ color: '#E56910' }}>
                  <FormattedMessage {...utilsMessages.updateStoreNoteText} />
                </p>
              </FormSubTitle>
            )}
          </TitleWrapper>
        )}
        <Form
          form={form}
          layout="vertical"
          size="large"
          onFinish={(values) => {
            const { taxCode, redInvoiceCompanyName, redInvoiceEmail, isSameAddress, redInvoiceAddress, ...restValues } =
              values;
            const isValidRedInvoice = validateRedInvoice({
              taxCode: taxCode,
              redInvoiceCompanyName: redInvoiceCompanyName,
              redInvoiceEmail: redInvoiceEmail,
              redInvoiceAddress: redInvoiceAddress,
            });
            if (!isValidRedInvoice) {
              return;
            }
            delete restValues.provinceId;
            delete restValues.districtId;
            delete restValues.addressDetail;

            const address = restValues.location?.formattedAddress || restValues.location?.address;
            delete restValues.location?.formattedAddress;
            const location = {
              ...restValues.location,
              address: address,
            };
            if (isUpdate && currentStoreData && Object.keys(currentStoreData).length) {
              const updatedData = {
                id: currentStoreData.id,
                disabled: currentStoreData.disabled,
                imageUrl: currentStoreData.imageUrl,
                ...restValues,
                location: location,
                name: currentStoreData.name,
                telephone: currentStoreData.telephone,
              };
              handleStoreInfo({ isUpdate: isUpdate, data: updatedData });
            } else {
              const isUpdateStore = !!buyer.stores?.[0]?.id && !buyer.stores?.[0]?.geoPlusCode ? true : isUpdate;
              const currentStore = buyer?.stores?.[0] || currentStoreData || {};
              handleStoreInfo({
                isUpdate: isUpdateStore,
                data: {
                  ...restValues,
                  id: isUpdateStore ? buyer?.stores?.[0]?.id : currentStoreData?.id || undefined,
                  location: location,
                  buyer: !isUpdateStore ? buyer : undefined,
                  disabled: currentStore.disabled,
                  imageUrl: storeImg || currentStore?.imageUrl || '',
                  redInvoice:
                    taxCode && redInvoiceCompanyName
                      ? {
                          taxCode: taxCode,
                          companyName: redInvoiceCompanyName,
                          emailToReceiveEInvoice: redInvoiceEmail || '',
                          location: {
                            address: isSameAddress ? restValues.location?.address : redInvoiceAddress || '',
                            district: '',
                            city: '',
                          },
                        }
                      : undefined,
                },
              });
            }
          }}
          style={{
            maxHeight: 570,
            overflowY: 'auto',
            overflowX: 'hidden',
            paddingRight: 10,
          }}
        >
          {isUpdate ? (
            <>
              <Row gutter={8} style={{ flexWrap: 'nowrap', marginBottom: '10px', justifyContent: 'center' }}>
                <StoreNameViewOnly>{currentStoreData?.name}</StoreNameViewOnly>
                <Col>
                  <SeparateLine span={1} />
                </Col>
                <Col>
                  <span>
                    <FormattedMessage {...utilsMessages.phoneNumber} />
                  </span>
                  :{currentStoreData?.telephone}
                </Col>
              </Row>
              <AddressForMap
                form={form}
                fieldNameFullText={FIELD_NAME_FULL_TEXT}
                fieldName={{
                  city: 'provinceId',
                  district: 'districtId',
                  addressDetail: 'addressDetail',
                  ward: 'wardId',
                  wardId: 'wardId',
                  geoLat: 'geoLat',
                  geoLon: 'geoLon',
                  geoPlusCode: 'geoPlusCode',
                }}
                // provinceValue={isUpdate ? fullAddress?.provinceCode : buyer?.fullAddress?.provinceCode}
                // districtValue={isUpdate ? fullAddress?.districtCode : buyer?.fullAddress?.districtCode}
                // wardValue={isUpdate ? fullAddress?.wardCode : buyer?.fullAddress?.wardCode}
                currentAddressDetail={currentAddressDetail}
                regions={regions}
                handleShowWarning={handleShowWarning}
                setOpenExtendedMap={setOpenExtendedMap}
                isOpenExtendedMap={openExtendedMap}
                setCoords={setCoords}
                setPlaceId={setPlaceId}
                placeId={placeId}
                setIsOutOfRegion={setIsOutOfRegion}
                setLoading={setLoading}
                isUpdate={isUpdate}
              />
            </>
          ) : (
            <UpdateInfoFirstStoreForm
              form={form}
              addressComponent={
                <AddressForMap
                  form={form}
                  fieldNameFullText={FIELD_NAME_FULL_TEXT}
                  fieldName={{
                    city: 'provinceId',
                    district: 'districtId',
                    addressDetail: 'addressDetail',
                    ward: 'wardId',
                    wardId: 'wardId',
                    geoLat: 'geoLat',
                    geoLon: 'geoLon',
                    geoPlusCode: 'geoPlusCode',
                  }}
                  // provinceValue={isUpdate ? fullAddress?.provinceCode : buyer?.fullAddress?.provinceCode}
                  // districtValue={isUpdate ? fullAddress?.districtCode : buyer?.fullAddress?.districtCode}
                  // wardValue={isUpdate ? fullAddress?.wardCode : buyer?.fullAddress?.wardCode}
                  currentAddressDetail={currentAddressDetail}
                  regions={regions}
                  handleShowWarning={handleShowWarning}
                  setOpenExtendedMap={setOpenExtendedMap}
                  isOpenExtendedMap={openExtendedMap}
                  setCoords={setCoords}
                  setPlaceId={setPlaceId}
                  placeId={placeId}
                  setIsOutOfRegion={setIsOutOfRegion}
                  setLoading={setLoading}
                  isUpdate={isUpdate}
                  hasFeedback={false}
                />
              }
              imageUrl={storeImg}
              onSetImageUrl={setStoreImg}
            />
          )}
          {/* {!placeId && <Spacing />} */}
          {openExtendedMap && coords && (
            <StoreMapWrapper
              form={form}
              fieldNameFullText={{
                addressDetail: FIELD_NAME_FULL_TEXT.addressDetail,
                address: 'addressDetail',
                geoLat: 'geoLat',
                geoLon: 'geoLon',
                geoPlusCode: 'geoPlusCode',
              }}
              hideMarker={!coords}
              coords={coords}
              setCoords={setCoords}
              placeId={placeId}
              setPlaceId={setPlaceId}
              isOutOfRegion={isOutOfRegion}
              setIsOutOfRegion={setIsOutOfRegion}
              openExtendedMap={openExtendedMap}
              setOpenExtendedMap={setOpenExtendedMap}
              currentRegion={regions?.[0] || ''}
            />
          )}
        </Form>
      </PopupCreateStore>
    </GoogleMapsContextProvider>
  );
};

const mapStateToProps = createStructuredSelector<ApplicationRootState, IStateProps>({
  buyer: selectBuyer(),
  createStorePopupState: selectCreateStorePopupComponent(),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  handleStoreInfo: (payload: any) => {
    dispatch(handleStore.request(payload));
  },
  findFullAddress: (payload: any) => dispatch(findFullAddress.request(payload)),
  gotoChangeStorePage: () => dispatch(push('/change-store')),
});

const withConnect = connect<IStateProps, IDispatchProps>(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer<IOwnProps>({ key: 'createStorePopupComponent', reducer: reducer });

const withSaga = injectSaga<IOwnProps>({ key: 'createStorePopupComponent', saga: saga });

export default compose(withReducer, withSaga, withConnect)(CreateStorePopup);
